module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetHigh.5a269bb.jpg";